(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4923],{

/***/ 346:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/not-found",
      function () {
        return __webpack_require__(95139);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 78796:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/auth-bg.2d8c7831.jpg","height":1920,"width":1560,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAcDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAbEAACAwADAAAAAAAAAAAAAAABAgADEQRCUf/EABUBAQEAAAAAAAAAAAAAAAAAAAQG/8QAGREAAwADAAAAAAAAAAAAAAAAAAECEVGx/9oADAMBAAIRAxEAPwCPetC1tJ4zVPVh09gfIiIYsZp1lvb6f//Z","blurWidth":7,"blurHeight":8});

/***/ }),

/***/ 95139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87379);
/* harmony import */ var src_components_TrackedLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79017);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(17739);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(react_t7e__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73098);
/* harmony import */ var src_components_common_ConstraintContainer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71008);
/* harmony import */ var src_components_common_Button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78296);
/* harmony import */ var src_assets_images_auth_bg_jpg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78796);
/* harmony import */ var src_styles_theme__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(68251);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  margin-bottom: -50px;\n  ",
        " {\n    margin-bottom: 0;\n    min-height: calc(\n      100vh - var(--header-static-height) - var(--header-fixed-height)\n    );\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        " {\n    width: 50%;\n    height: 100%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: max-content;\n  margin: 0 auto;\n  padding: 30px 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 300;\n  font-size: 24px;\n  line-height: 110%;\n  color: ",
        ";\n  ",
        " {\n    font-size: 36px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 300;\n  font-size: 14px;\n  line-height: 1.5;\n  margin: 16px 0 32px;\n  ",
        " {\n    font-size: 16px;\n    margin: 20px 0 40px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 100%;\n  height: 370px;\n  clip-path: polygon(0 0, 100% 0, 100% 100%, 15% 100%);\n  ",
        " {\n    position: absolute;\n    bottom: 0;\n    top: 0;\n    right: 0;\n    width: 50%;\n    height: calc(100% + var(--footer-static-height));\n  }\n  ",
        " {\n    right: auto;\n    left: 0;\n    transform: scaleX(-1);\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-width: 158px !important;\n  ",
        " {\n    min-width: 264px !important;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}











var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].section.withConfig({
    displayName: "not-found__Wrapper",
    componentId: "sc-4a2fb9e1-0"
})(_templateObject(), src_styles_designs__WEBPACK_IMPORTED_MODULE_5__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var ContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].div.withConfig({
    displayName: "not-found__ContentWrapper",
    componentId: "sc-4a2fb9e1-1"
})(_templateObject1(), src_styles_designs__WEBPACK_IMPORTED_MODULE_5__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var Content = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].div.withConfig({
    displayName: "not-found__Content",
    componentId: "sc-4a2fb9e1-2"
})(_templateObject2());
var Title = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].h1.withConfig({
    displayName: "not-found__Title",
    componentId: "sc-4a2fb9e1-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.text.palette.neauvia;
}, src_styles_designs__WEBPACK_IMPORTED_MODULE_5__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var Description = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].p.withConfig({
    displayName: "not-found__Description",
    componentId: "sc-4a2fb9e1-4"
})(_templateObject4(), src_styles_designs__WEBPACK_IMPORTED_MODULE_5__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var ImageContainer = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].div.withConfig({
    displayName: "not-found__ImageContainer",
    componentId: "sc-4a2fb9e1-5"
})(_templateObject5(), src_styles_designs__WEBPACK_IMPORTED_MODULE_5__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, src_styles_theme__WEBPACK_IMPORTED_MODULE_9__/* .dirRTL */ .gX);
var StyledButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__["default"])(src_components_common_Button__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .zx).attrs({
    forwardedAs: "a"
}).withConfig({
    displayName: "not-found__StyledButton",
    componentId: "sc-4a2fb9e1-6"
})(_templateObject6(), src_styles_designs__WEBPACK_IMPORTED_MODULE_5__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var NotFoundPage = function() {
    var _ = (0,react_t7e__WEBPACK_IMPORTED_MODULE_11__.useTranslate)()._;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_ConstraintContainer__WEBPACK_IMPORTED_MODULE_6__/* .ConstraintContainer */ .a, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ContentWrapper, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Content, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Title, {
                                children: _("404 Page not found")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Description, {
                                children: _("Page you were looking for was not found.")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_TrackedLink__WEBPACK_IMPORTED_MODULE_3__/* .TrackedLink */ .A, {
                                href: "/",
                                passHref: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButton, {
                                    children: _("Go to main page")
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImageContainer, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                    src: src_assets_images_auth_bg_jpg__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
                    layout: "fill",
                    objectFit: "cover"
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (NotFoundPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(346); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);